
import { useEffect, useRef, useState } from "react";
import { AiFillHeart } from "react-icons/ai";
import { BsCartFill } from "react-icons/bs";
import {
  FaBoxOpen,
  FaConciergeBell,
  FaEnvelope,
  FaFacebookF,
  FaHome,
  FaInfoCircle,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaQuestionCircle,
  FaSearch,
  FaShieldAlt,
  FaThLarge, FaUser,
  FaWhatsapp,
  FaYoutube
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import { Link } from "react-router-dom";
import logo from "./sulav_sewa_logo-3.png";

function Header() {
  const [isCompact, setIsCompact] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [cartCount, setCartCount] = useState(0);
  const lastScrollY = useRef(0);

  const getWishlistCount = () => {
    try {
      const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
      return Array.isArray(wishlist) ? wishlist.length : 0;
    } catch {
      return 0;
    }
  };

  const getCartCount = () => {
    try {
      const cart = JSON.parse(localStorage.getItem("cart")) || [];
      if (!Array.isArray(cart)) return 0;
      return cart.reduce((sum, item) => sum + (item.quantity || 1), 0);
    } catch {
      return 0;
    }
  };

  const updateHeaderCounts = () => {
    setWishlistCount(getWishlistCount());
    setCartCount(getCartCount());
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      setIsCompact(currentScroll > lastScrollY.current && currentScroll > 50);
      lastScrollY.current = currentScroll;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    updateHeaderCounts();

    window.addEventListener("storage", updateHeaderCounts);
    window.addEventListener("focus", updateHeaderCounts);

    const interval = setInterval(updateHeaderCounts, 800);

    return () => {
      window.removeEventListener("storage", updateHeaderCounts);
      window.removeEventListener("focus", updateHeaderCounts);
      clearInterval(interval);
    };
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
    {/* Top Bar menu  */}
      <div className="top-bar">
  <div className="top-left">
    <Link to="/about" onClick={scrollToTop}>
      <FaInfoCircle className="top-icon" /> About Us
    </Link>
    <span className="divider">|</span>

    <Link to="/faq" onClick={scrollToTop}>
      <FaQuestionCircle className="top-icon" /> FAQ
    </Link>
    <span className="divider">|</span>

    <Link to="/privacy" onClick={scrollToTop}>
      <FaShieldAlt className="top-icon" /> Privacy Policy
    </Link>
  </div>

  <div className="top-right">
    <Link to="#" onClick={scrollToTop}>
      <FaBoxOpen className="top-icon" /> Warranty
    </Link>
    <span className="divider">|</span>

    <Link to="/cart" onClick={scrollToTop}>
      <FaMapMarkerAlt className="top-icon" /> Pickup Location
    </Link>
    <span className="divider">|</span>

    <Link to="/contact" onClick={scrollToTop}>
      <FaPhoneAlt className="top-icon" /> +977-9869838769
    </Link>
  </div>
</div>

      {/* Main Navigation */}
      <div className={`Navigation ${isCompact ? "compact" : ""}`}>
        <div className="menu-search-compare">
          <div className="search-container">
            <img
              src={logo}
              alt="icon"
              className="left-logo"
            />
            <input className="Search" type="text" placeholder="Search Items" />
            <button className="search-button">
              <FaSearch />
            </button>
          </div>

          <div className="menu-items desktop-menu">
            <Link to="/" onClick={scrollToTop}>Home</Link>
            <Link to="/product" onClick={scrollToTop}>Product</Link>
            <Link to="/service" onClick={scrollToTop}>Service</Link>
            <Link to="/about" onClick={scrollToTop}>About Us</Link>
            <Link to="/contact" onClick={scrollToTop}>Contact Us</Link>
          </div>

          <Link to="/signin" className="login" onClick={scrollToTop}>
            <FaUser className="fancy-icon" />
            Account
          </Link>

          <div className="header-right">
            <Link to="/wishlist" className="wishlist" onClick={scrollToTop}>
              <AiFillHeart
                className="fancy-icon"
                style={{ color: "#ff1744" }}
              />
              {wishlistCount > 0 && (
                <span className="header-badge">
                  {wishlistCount > 99 ? "99+" : wishlistCount}
                </span>
              )}
              Wishlist
            </Link>
            <Link to="/cart" className="cart" onClick={scrollToTop}>
              <BsCartFill className="fancy-icon" style={{ color: "#ff9800" }} />
              {cartCount > 0 && (
                <span className="header-badge">
                  {cartCount > 99 ? "99+" : cartCount}
                </span>
              )}
              Cart
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Top Bar */}
      <div className="mobile-top-bar">
        <img
          src={logo}
          alt="Logo"
          className="mobile-logo"
        />

        <div className="mobile-quick-actions">
          <a className="mobile-phone-link" href="tel:+9779869838769" aria-label="Call us">
            <FaPhoneAlt />
            <span>9869838769</span>
          </a>
          {/* <Link to="/cart" className="mobile-cart-link" onClick={scrollToTop} aria-label="Go to cart">
            <BsCartFill />
            {cartCount > 0 && (
              <span className="header-badge">
                {cartCount > 99 ? "99+" : cartCount}
              </span>
            )}
          </Link> */}
        </div>

        <div className="mobile-search-wrapper">
          <input
            type="text"
            className="mobile-search"
            placeholder="Search Items"
          />
          <button className="mobile-search-btn" aria-label="Search">
            <FaSearch />
          </button>
        </div>

        <div
          className="mobile-menu-btn"
          onClick={toggleMenu}
          role="button"
          tabIndex={0}
          aria-label="Open menu"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") toggleMenu();
          }}
        >
          &#9776;
        </div>
      </div>

      {/* Mobile Drawer */}
      {menuOpen && (
        <div className="mobile-drawer open">
              <button
      className="close-btn"
      onClick={() => setMenuOpen(false)}
    >
      ✕
    </button>
          <div className="login-card">
            <div>
              <h3>Hello there,</h3>
              <p>Please login/signup</p>
            </div>
            <Link to="/signin" className="login-btn" onClick={scrollToTop}>
              Login
            </Link>
          </div>

          <div className="menu-section">
            <h4>Shop by</h4>
            <Link to="/categories" className="menu-item" onClick={scrollToTop}>
              <span>📦 Category</span>
              <span>›</span>
            </Link>
            <Link to="/brands" className="menu-item" onClick={scrollToTop}>
              <span>🏷️ Brand</span>
              <span>›</span>
            </Link>
          </div>

          <div className="menu-section">
            <h4>Account</h4>
            <Link to="/profile" className="menu-item" onClick={scrollToTop}>
              <span>👤 My Profile</span>
              <span>›</span>
            </Link>
            <Link to="/orders" className="menu-item" onClick={scrollToTop}>
              <span>📦 My Orders</span>
              <span>›</span>
            </Link>
            <Link to="/wishlist" className="menu-item" onClick={scrollToTop}>
              <span>❤️ Wishlist</span>
              <span>›</span>
            </Link>
          </div>

          <div className="menu-section">
            <h4>About</h4>
            <Link to="/about" className="menu-item" onClick={scrollToTop}>
              <span>ℹ️ About Us</span>
              <span>›</span>
            </Link>
            <Link to="/contact" className="menu-item" onClick={scrollToTop}>
              <span>🎧 Contact Us</span>
              <span>›</span>
            </Link>
            <Link to="/store" className="menu-item" onClick={scrollToTop}>
              <span>📍 Store Location</span>
              <span>›</span>
            </Link>
          </div>

          <div className="menu-section">
            <h4>Help</h4>
            <Link to="/faq" className="menu-item" onClick={scrollToTop}>
              <span>❓ FAQs</span>
              <span>›</span>
            </Link>
            <Link to="/terms-conditions" className="menu-item" onClick={scrollToTop}>
              <span>📄 Terms & Conditions</span>
              <span>›</span>
            </Link>
            <Link to="/privacy" className="menu-item" onClick={scrollToTop}>
              <span>🔒 Privacy Policy</span>
              <span>›</span>
            </Link>
          </div>
        </div>
      )}

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/9779869838769"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <FaWhatsapp />
      </a>

      {/* Mobile Bottom Navigation */}
      <div className="mobile-bottom-nav">
        <Link to="/" className="nav-item" onClick={scrollToTop}>
          <FaHome />
          <span>Home</span>
        </Link>

        <Link to="/product" className="nav-item" onClick={scrollToTop}>
          <FaThLarge />
          <span>Product</span>
        </Link>

        <Link to="/service" className="nav-item" onClick={scrollToTop}>
          <FaConciergeBell />
          <span>Service</span>
        </Link>

        <Link to="/cart" className="nav-item" onClick={scrollToTop}>
          <BsCartFill />
          {cartCount > 0 && (
            <span className="header-badge">
              {cartCount > 99 ? "99+" : cartCount}
            </span>
          )}
          <span>Cart</span>
        </Link>

        <Link to="/signin" className="nav-item" onClick={scrollToTop}>
          <FaUser />
          <span>Profile</span>
        </Link>
      </div>
    </>
  );
}

export default Header;

function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-brand-block">
          <Link to="/" className="footer-brand" onClick={scrollToTop}>
            <img src="/Logo/updated-logo.png" alt="Sulav Sewa" />
            <h2>
              <span className="blue-text">Sulav</span>
              <span className="yellow-text">Sewa</span>
            </h2>
          </Link>

          <p className="footer-description">
            Trusted doorstep support for products and services across Kathmandu.
          </p>

          <div className="footer-contact-list">
            <a href="https://maps.app.goo.gl/KT22mfBMX95QF7op7" target="_blank" rel="noopener noreferrer">
              <FaHome /> Gongabu, Kathmandu
            </a>
            <a href="mailto:sulavsewa4@gmail.com">
              <FaEnvelope /> sulavsewa4@gmail.com
            </a>
            <a href="tel:+9779869838769">
              <FaPhoneAlt /> +977-9869838769
            </a>
          </div>
        </div>

        <div className="footer-link-group">
          <h3>Company</h3>
          <Link to="/about" onClick={scrollToTop}>About Us</Link>
          <Link to="/delivery-info" onClick={scrollToTop}>Delivery Information</Link>
          <Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link>
          <Link to="/terms-conditions" onClick={scrollToTop}>Terms and Conditions</Link>
          <Link to="/contact" onClick={scrollToTop}>Contact Us</Link>
          <Link to="/support-center" onClick={scrollToTop}>Support Center</Link>
          <Link to="/careers" onClick={scrollToTop}>Careers</Link>
        </div>

        <div className="footer-link-group">
          <h3>Account</h3>
          <Link to="/signin" onClick={scrollToTop}>Sign In</Link>
          <Link to="/cart" onClick={scrollToTop}>View Cart</Link>
          <Link to="/wishlist" onClick={scrollToTop}>My Wishlist</Link>
          <Link to="/cart" onClick={scrollToTop}>Track My Order</Link>
          <Link to="/contact" onClick={scrollToTop}>Help Ticket</Link>
          <Link to="/cart" onClick={scrollToTop}>Shipping Details</Link>
        </div>

        <div className="footer-social-block">
          <h3>Follow Us</h3>
          <p>Get updates, offers, and service news on social media.</p>

          <div className="footer-social-grid">
          <a
            href="https://www.facebook.com/profile.php?id=61573390263057"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-item"
          >
            <FaFacebookF style={{ color: "#1877F2" }} /> <span>Facebook</span>
          </a>
          <a
            href="https://www.instagram.com/sulavsewa4/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-item"
          >
            <FaInstagram style={{ color: "#E4405F" }} />
            <span>Instagram</span>{" "}
          </a>
          <a
            href="https://www.youtube.com/channel/UC6GOIa0cil8rflnyLcAFIKw"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-item"
          >
            <FaYoutube style={{ color: "#FF0000" }} /> <span>YouTube</span>
          </a>
          <a
            href="https://www.tiktok.com/@sulav_sewa"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-item"
          >
            <SiTiktok style={{ color: "#000000" }} /> <span>TikTok</span>
          </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>Copyright {currentYear} Sulav Sewa. All rights reserved.</span>
        <div className="footer-bottom-links">
          <Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link>
          <Link to="/terms-conditions" onClick={scrollToTop}>Terms and Conditions</Link>
        </div>
      </div>
    </footer>
  );
}
export { Footer };

